<div class="fb-properties" *ngIf="configuredField; else emptyState">
  <div class="fb-properties__header">
    <div class="fb-properties__title">
      <span class="fb-properties__field-label">{{ fieldLabel }}</span>
      <span class="fb-properties__field-type">({{ fieldType }})</span>
    </div>
    <button class="fb-properties__close" (click)="closePanel()" title="Close">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <div class="fb-properties__search">
    <input
      type="text"
      class="fb-properties__search-input"
      [(ngModel)]="searchQuery"
      (ngModelChange)="onSearchChange()"
      placeholder="Search properties..." />
  </div>

  <div class="fb-properties__tabs">
    <button
      *ngFor="let tab of tabs; trackBy: trackByTabKey"
      class="fb-properties__tab"
      [class.active]="selectedTab === tab.key"
      (click)="onTabChange(tab.key)"
      [title]="tab.label">
      <i [class]="tab.icon"></i>
      <span>{{ tab.label }}</span>
    </button>
  </div>

  <div class="fb-properties__content">
    <!-- Settings Tab -->
    <div
      *ngIf="selectedTab === EPropertyTab.Settings"
      class="fb-properties__tab-content">
      <formly-form
        [form]="settingsForm"
        [fields]="displayedSettingsFields"
        [model]="settingsModel"
        [options]="settingsOptions"
        (modelChange)="onSettingsModelChange()">
      </formly-form>
      <p
        *ngIf="searchQuery && !displayedSettingsFields.length"
        class="fb-properties__no-results">
        No settings match "{{ searchQuery }}"
      </p>
    </div>

    <!-- Validation Tab -->
    <div
      *ngIf="selectedTab === EPropertyTab.Validation"
      class="fb-properties__tab-content">
      <formly-form
        [form]="validationForm"
        [fields]="displayedValidationFields"
        [model]="validationModel"
        [options]="validationOptions"
        (modelChange)="onValidationModelChange()">
      </formly-form>
      <p
        *ngIf="searchQuery && !displayedValidationFields.length"
        class="fb-properties__no-results">
        No validations match "{{ searchQuery }}"
      </p>
    </div>

    <!-- Expressions Tab -->
    <div
      *ngIf="selectedTab === EPropertyTab.Expressions"
      class="fb-properties__tab-content">
      <irembogov-fb-expression-editor
        [field]="configuredField"
        (expressionsChanged)="onExpressionsChanged()">
      </irembogov-fb-expression-editor>
    </div>

    <!-- JSON Tab -->
    <div
      *ngIf="selectedTab === EPropertyTab.Json"
      class="fb-properties__tab-content">
      <div class="fb-properties__json-hint">
        <i class="fa-solid fa-circle-info"></i>
        Full field JSON. Edit expressions, props, validators, className, hide,
        defaultValue directly.
      </div>
      <ngx-monaco-editor
        class="fb-properties__json-editor"
        [options]="jsonEditorOptions"
        [(ngModel)]="fieldJsonCode"
        (ngModelChange)="onJsonCodeChange($event)">
      </ngx-monaco-editor>
      <div class="fb-properties__json-error" *ngIf="jsonValidationError">
        <i class="fa-solid fa-triangle-exclamation"></i>
        {{ jsonValidationError }}
      </div>
      <div class="fb-properties__json-actions">
        <button
          class="btn btn-sm btn-primary"
          (click)="applyJsonChanges()"
          [disabled]="!!jsonValidationError">
          <i class="fa-solid fa-check"></i> Apply
        </button>
      </div>
    </div>
  </div>

  <!-- Manual save for Settings + Validation. Once saved, the form's existing
       autosave persists it. Other tabs manage their own apply. -->
  <div
    class="fb-properties__footer"
    *ngIf="
      selectedTab === EPropertyTab.Settings ||
      selectedTab === EPropertyTab.Validation
    ">
    <span
      class="fb-properties__status"
      [class.fb-properties__status--dirty]="isDirty">
      <i [class]="isDirty ? 'fa-solid fa-circle' : 'fa-solid fa-check'"></i>
      {{ isDirty ? 'Unsaved changes' : 'Saved' }}
    </span>
    <div class="fb-properties__footer-actions">
      <button
        class="fb-properties__btn fb-properties__btn--ghost"
        (click)="discard()"
        [disabled]="!isDirty">
        Discard
      </button>
      <button
        class="fb-properties__btn fb-properties__btn--primary"
        (click)="save()"
        [disabled]="!isDirty">
        <i class="fa-solid fa-check"></i> Save
      </button>
    </div>
  </div>
</div>

<ng-template #emptyState>
  <irembogov-fb-component-palette (addField)="onPaletteAddField($event)">
  </irembogov-fb-component-palette>
</ng-template>

<!-- In-panel confirmation modal: unsaved-changes guard + key-rename prompt -->
<div class="fb-confirm-modal" *ngIf="confirmDialog">
  <div
    class="fb-confirm-modal__backdrop"
    (click)="onConfirmDialogCancel()"></div>
  <div class="fb-confirm-modal__dialog" role="dialog" aria-modal="true">
    <h6 class="fb-confirm-modal__title">{{ confirmDialog.title }}</h6>
    <p class="fb-confirm-modal__message">{{ confirmDialog.message }}</p>
    <div class="fb-confirm-modal__actions">
      <button
        class="fb-properties__btn fb-properties__btn--ghost"
        (click)="onConfirmDialogCancel()">
        {{ confirmDialog.cancelLabel }}
      </button>
      <button
        class="fb-properties__btn fb-properties__btn--primary"
        (click)="onConfirmDialogConfirm()">
        {{ confirmDialog.confirmLabel }}
      </button>
    </div>
  </div>
</div>
